/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Microsoft" |
*
* @param {Voice_Manager_Provider_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_microsoft = /** @type {((inputs?: Voice_Manager_Provider_MicrosoftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_MicrosoftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Microsoft")
	if (locale === "de") return /** @type {LocalizedString} */ ("Microsoft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Microsoft")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Microsoft")
	if (locale === "es") return /** @type {LocalizedString} */ ("Microsoft")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("微软")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マイクロソフト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("माइक्रोसॉफ्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Microsoft")
	return /** @type {LocalizedString} */ ("Microsoft")
});